import { endOfDay, startOfDay, subDays } from 'date-fns';

export const getDefaultFilter = () => {
  return {
    period: {
      startDate: startOfDay(subDays(new Date(), 7)).toISOString(),
      endDate: endOfDay(new Date()).toISOString(),
    },
    posIds: [],
    merchantIds: [],
    statuses: [],
  };
};
